import * as Yup from 'yup';
import * as moment from 'moment';
import { FORMAT, BIDFORMAT } from '../utils/dateOfBirthValidation';

export function getInitialValues(manageAccountPageData) {
    let isDeliveryAvailable = 'true';
    if (manageAccountPageData.isDeliveryAvailable) isDeliveryAvailable = manageAccountPageData.isDeliveryAvailable?.toString()

    return {
        vehiclePreferences: (manageAccountPageData?.postPreferences?.vehiclePreferences?.length > 0 && manageAccountPageData?.postPreferences?.vehiclePreferences[0]) || '',
        dropLive: manageAccountPageData?.postPreferences?.unloadingReq === 'DROP' ? 'DROP' : 'LIVE',
        isDeliveryAvailable: isDeliveryAvailable || true,
        distanceWillingToTravel: manageAccountPageData.distanceWillingToTravel || '',
        deliveryTime: manageAccountPageData.deliveryTime || '',

        appointment: 'DELIVERY',
        deliveryWindowBegin: manageAccountPageData?.postPreferences?.buyerDelPrefWindowBegin || '08:00',
        deliveryWindowEnd: manageAccountPageData?.postPreferences?.buyerDelPrefWindowEnd || '17:00',
    }
}
const VALIDATION_SCHEMA = Yup.object().shape({
});

export { VALIDATION_SCHEMA };